import type { SxProps, Theme } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import { useRollMaterials } from "../hooks/useBarrels";

interface RollMaterialSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	size?: "small" | "medium";
	required?: boolean;
	sx?: SxProps<Theme>;
}

/** 76 materials, so the list is searched; clearing it leaves the barrel without one. */
export const RollMaterialSelector = ({
	value,
	onChange,
	label = "Roll Material",
	fullWidth = false,
	size = "small",
	required = false,
	sx,
}: RollMaterialSelectorProps) => {
	const { data: materials = [], isLoading } = useRollMaterials();
	const selected = materials.find((material) => material.Id === value) ?? null;

	return (
		<Autocomplete
			options={materials}
			value={selected}
			size={size}
			fullWidth={fullWidth}
			disabled={isLoading}
			autoHighlight
			getOptionLabel={(option) => option.Name}
			isOptionEqualToValue={(option, current) => option.Id === current.Id}
			onChange={(_event, option) => onChange(option?.Id ?? null)}
			renderOption={(props, option) => {
				const { key, ...rest } = props as typeof props & { key: string };
				return (
					<li key={option.Id} {...rest}>
						{option.Name}
					</li>
				);
			}}
			sx={{ minWidth: 120, ...sx } as SxProps<Theme>}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					required={required}
					slotProps={{ inputLabel: { shrink: true } }}
				/>
			)}
		/>
	);
};
